export const isRelativeUrl = (url: string): boolean => {
  return /^\/(?!\/)/.test(url); // Just some basic check
};
